import { StatusResult } from "../types/types";
import SnapshotChart from "./charts/SnapshotChart";
import { SnapshotResult } from "./tables/SnapshotResult";

type SnapshotViewProps = {
  data: StatusResult;
}
const SnapshotView = (props: SnapshotViewProps) => {
  return (
    <>
      <SnapshotResult />
      <SnapshotChart data={props.data} />
    </>
  );
};

export default SnapshotView;
